import _ from 'lodash';

const getEnv = () => {
    let env = "development";
    if (_.includes(window.location.href, '.jvsonline.fr')) {
        env = "production";
    } else if (_.includes(window.location.href, '.qa.')) {
        env = "testing";
    } else if (_.includes(window.location.href, '.pp.')) {
        env = "staging";
    } else {
        env = "development";
    }
  return env;
};

export default getEnv;